import React from 'react';
import {Typography} from '@bonprix/design-system';

export default function UserFlyoutTextItem({text}) {

    return (
        <Typography component="div" variant='body1' color="on-primary-mid">
            {text}
        </Typography>
    );
}
